
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upsc-mains-crash-course",
      function () {
        return require("private-next-pages/upsc-mains-crash-course/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upsc-mains-crash-course"])
      });
    }
  